import { z } from "zod";

export const accountTypeSchema = z.enum(["Customer", "Vendor", "Customer & Vendor"]);

export const createAccountSchema = z.object({
  name: z.string().trim().min(1, "Name is required"),
  uid: z.string().trim().min(1, "UID is required"),
  type: accountTypeSchema,
  photo: z.string().nullable().optional(),
});

export const updateAccountSchema = z.object({
  name: z.string().trim().min(1).optional(),
  uid: z.string().trim().min(1).optional(),
  type: accountTypeSchema.optional(),
  photo: z.string().nullable().optional(),
});

export type AccountType = z.infer<typeof accountTypeSchema>;
